module.exports = __webpack_public_path__ + "img/12345.5c695fce.png";